import { render } from "./WarningSection.vue?vue&type=template&id=1b46a8a5&ts=true"
import script from "./WarningSection.vue?vue&type=script&lang=ts"
export * from "./WarningSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__